// extracted by mini-css-extract-plugin
export default {"doc-page-wrapper":"l_Y container-lg d-flex p-3","doc-page":"l_Z","doc-page__title--enterprise":"l_0","doc-page--with-side-menu":"l_1","doc-page__title":"l_2"};